<template>
  <q-select
    :model-value="selectedUserClient"
    label="Name, email or file ref no."
    :options="sortedUserClients"
    :option-label="optionLabel"
    option-value="id"
    :loading="loading"
    use-input clearable filled dense
    :input-debounce="wait"
    clear-icon="fa fa-times"
    @update:model-value="change"
    @filter="filter"
    @focus="onFocus"
  >
    <template v-slot:prepend>
      <q-icon name="fa fa-search" size="xs" color="primary" />
    </template>
    <template v-slot:option="scope">
      <q-item v-bind="scope.itemProps">
        <q-item-section side>
          <star size="xs" :user-client="scope.opt" />
        </q-item-section>
        <q-item-section>
          <q-item-label>
            {{ $filters.clientName(scope.opt.client) }}
          </q-item-label>
          <q-item-label caption>
            {{ scope.opt.client.email }}, #{{ scope.opt.client.fileRefNo}}
          </q-item-label>
        </q-item-section>
      </q-item>
    </template>
  </q-select>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import { UserClient, UserClientFilters } from '@/type';
import { UserContextMixin } from '@/mixins';
import { name as clientNameFilter } from '@/client/client-filter';
import Star from '@/user-client/Star.vue';
import repository from './userClientRepository';

interface Data {
  loaded: Boolean,
  task: Promise<UserClient[]>|null,
  loading: Boolean,
  userClients: UserClient[],
  keyword: string|null,
  selectedUserClient: UserClient|null,
}

export default defineComponent({
  mixins: [UserContextMixin],
  emits: ['change'],
  props: {
    wait: {
      type: Number,
      default: 1000,
    },
  },
  data(): Data {
    return {
      loaded: false,
      task: null,
      loading: false,
      userClients: [],
      keyword: null,
      selectedUserClient: null,
    };
  },
  watch: {
    task(newTask) {
      this.loading = true;
      newTask.finally(() => {
        this.loading = false;
      });
    },
    keyword() {
      this.load();
    },
  },
  computed: {
    sortedUserClients(): UserClient[] {
      return _.sortBy(this.userClients, userClient => userClient.starredAt === null);
    },
  },
  methods: {
    change(userClient: UserClient|null): void {
      this.selectedUserClient = userClient;
      if (userClient) {
        this.$emit('change', userClient);
      }
    },
    optionLabel(userClient: UserClient): string {
      return clientNameFilter(userClient.client);
    },
    filter(inputValue: string, done: Function): void {
      if (inputValue) {
        this.keyword = inputValue;
      }
      done();
    },
    onFocus(): void {
      if (this.loaded) return;
      this.loaded = true;
      this.load();
    },
    load(): void {
      const filters: UserClientFilters = {
        keyword: (this.keyword) ? this.keyword : undefined,
      };
      // @ts-ignore
      this.task = repository.findAll(this.userId, filters);
      if (this.task) {
        this.task.then((userClients: UserClient[]) => {
          // @ts-ignore
          this.userClients = userClients;
        });
      }
    },
  },
  components: {
    star: Star,
  },
  filters: {
    clientName: clientNameFilter,
  },
});
</script>
